import { ID, Reminder, ReminderBasedOn } from '@griply/types';

type ReminderTiming = Pick<Reminder, 'offset' | 'basedOn'>;

export const isSameReminder = (a: ReminderTiming, b: ReminderTiming): boolean =>
  a.offset === b.offset && a.basedOn === b.basedOn;

export const removeReminder = (
  reminders: Reminder[],
  target: ReminderTiming,
): Reminder[] =>
  reminders.filter((reminder) => !isSameReminder(reminder, target));

export const toggleReminder = (
  reminders: Reminder[],
  reminder: Reminder,
): Reminder[] =>
  reminders.some((existing) => isSameReminder(existing, reminder))
    ? removeReminder(reminders, reminder)
    : [...reminders, reminder];

// An empty array means "explicitly no reminders" — only a missing array falls back to the legacy value.
export const shouldShowLegacyReminder = (
  reminders: Reminder[] | null | undefined,
  reminderTime: number | null | undefined,
): reminderTime is number => reminders == null && reminderTime != null;

// A legacy time-of-day fires at that clock time on the task's day — a DayStart reminder with the same offset.
export const legacyReminderTimeToReminder = (
  reminderTime: number,
  id?: ID | null,
): Reminder => ({
  id: id ?? null,
  offset: reminderTime,
  basedOn: ReminderBasedOn.DayStart,
});

export const resolveTaskReminders = (
  reminders: Reminder[] | null | undefined,
  reminderTime: number | null | undefined,
): Reminder[] | null => {
  if (shouldShowLegacyReminder(reminders, reminderTime)) {
    return [legacyReminderTimeToReminder(reminderTime)];
  }
  return reminders ?? null;
};
